import { render, staticRenderFns } from "./BayiTanimlama.vue?vue&type=template&id=c6fe1a8a&scoped=true&"
import script from "./BayiTanimlama.vue?vue&type=script&lang=js&"
export * from "./BayiTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./BayiTanimlama.vue?vue&type=style&index=0&id=c6fe1a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fe1a8a",
  null
  
)

export default component.exports